import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const TrendUpIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M20.0999 6.00488C20.3286 6.02772 20.5443 6.12899 20.7083 6.29297C20.8956 6.48047 21.0002 6.73496 21.0002 7V13C21.0002 13.5522 20.5524 13.9999 20.0002 14C19.448 14 19.0002 13.5523 19.0002 13V9.44043L14.8674 13.6387C14.7705 13.7371 14.6922 13.817 14.6165 13.8848C13.4775 14.9042 11.7545 14.9042 10.6155 13.8848C10.5405 13.8176 10.464 13.7397 10.3645 13.6387C10.2491 13.5215 10.2229 13.4962 10.2053 13.4805C9.82568 13.1407 9.25101 13.1408 8.87134 13.4805C8.85389 13.4961 8.82779 13.5222 8.71313 13.6387L4.71313 17.7012C4.32581 18.0945 3.69265 18.0999 3.29907 17.7129C2.90566 17.3255 2.90025 16.6924 3.28735 16.2988L7.28833 12.2354C7.38208 12.1401 7.46203 12.0585 7.53833 11.9902C8.67738 10.971 10.4004 10.9708 11.5393 11.9902C11.6157 12.0586 11.6951 12.1406 11.7893 12.2363C11.8996 12.3484 11.9305 12.3775 11.9495 12.3945C12.3291 12.7342 12.9028 12.7343 13.2825 12.3945C13.3007 12.3782 13.3292 12.3505 13.4417 12.2363L17.6135 8H14.0002C13.448 8 13.0002 7.55228 13.0002 7C13.0002 6.44772 13.448 6 14.0002 6H20.0002L20.0999 6.00488Z'
        fill={color}
      />
    </svg>
  )
})
